import { createAction, props } from '@ngrx/store';
import { IAddDefaultPaymentMethodRequest } from '../models/add-default-payment-method.model';

export const loadAddDefaultPaymentMethod = createAction(
  '[AddDefaultPaymentMethod] Load Add Default Payment Method',
  props<{ request: IAddDefaultPaymentMethodRequest }>()
);

export const loadAddDefaultPaymentMethodSuccess = createAction(
  '[AddDefaultPaymentMethod] Load Add Default Payment Method Success',
  props<{ response: string }>()
);

export const loadAddDefaultPaymentMethodFailure = createAction(
  '[AddDefaultPaymentMethod] Load Add Default Payment Method Failure',
  props<{ error: Error | any }>()
);
